import React from 'react';

interface VenereHeartProps {
  size?: number;
  className?: string;
  color?: string;
  onClick?: () => void;
}

export const VenereHeart: React.FC<VenereHeartProps> = ({
  size = 24,
  className = '',
  color = 'currentColor',
  onClick,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 2000 2000"
      fill={color}
      className={className}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <path d="M1605.24,572.46h0c-16.51,16.51-20.92,41.75-10.51,62.64,18.68,37.47,28.58,79.04,28.58,122.15-.07,73.35-28.59,142.18-80.35,194.01h0s-542.95,542.95-542.95,542.95l-384.44-384.51h55.39c19.26,0,37.09-10.08,47.03-26.6l116.34-193.94,172.89,302.59c9.8,17.07,27.97,27.63,47.64,27.63h1.51c20.22,0,38.46-12.2,47.51-30.3l94.6-189.06h128.31c30.04,0,56.22-23.16,57.1-53.18.92-31.06-23.96-56.5-54.82-56.5h-164.53c-20.77,0-39.76,11.72-49.08,30.3l-63.82,127.71-168.57-294.92c-9.67-16.86-27.56-27.42-47.03-27.63-21.94-.34-37.57,9.94-47.64,26.6l-148.49,247.61h-133.47c-.14,0-.27.07-.48.07l-48.88-48.88c-51.76-51.76-80.27-120.65-80.27-193.94s28.52-142.11,80.27-193.94c51.76-51.76,120.65-80.28,193.94-80.28s142.11,28.52,193.94,80.28l116.33,116.34c21.32,21.32,56.21,21.32,77.54,0l116.33-116.34c51.76-51.76,120.66-80.28,193.94-80.28,41.77,0,82.09,9.27,118.63,26.83,20.82,10,45.7,5.53,62.03-10.8l.03-.03c26.71-26.71,19.05-71.88-15.02-88.21-51.08-24.49-107.43-37.41-165.75-37.41-102.56,0-198.94,39.9-271.48,112.43l-77.53,77.6-72.81-72.82c-74.37-74.37-175.04-118.2-280.21-117.13-112.07,1.14-216.47,49.96-290.02,136.94-51.01,60.32-82.1,135.65-88.54,214.38-9.37,114.57,30.93,223.87,111.09,304.04l581.69,581.74c10.76,10.63,24.75,15.97,38.8,15.97s28.04-5.35,38.8-16.04l581.69-581.74c72.53-72.46,112.43-168.92,112.43-271.48,0-60.07-13.73-117.99-39.67-170.25-16.71-33.67-61.43-41.19-88-14.61Z"/>
    </svg>
  );
};

export default VenereHeart; 